const Footer = () => (
  <footer className="footer">
    <div className="content has-text-centered has-text-white is-size-7">
      Statspace Plan-&#x3e;Hire-&#x3e;Deploy v{process.env.REACT_APP_VERSION}
    </div>
  </footer>
)

export default Footer
